export const publicRoute = ["public-applicant"];
